import { SeeAllCard } from 'src/pages/consumer/dish-first/explore/components/SeeAllCard';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import { generateThumborImgUrl } from 'src/shared/design-system/DynamicImage';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';
import { minScreen } from 'web-common/src/shared/utils/StyledComponentUtils';

export const PADDING = 16;
export const SHADOW_BREATHING_ROOM = 36;
export const IS_ONSCREEN_THRESHOLD = 32;

export const BackgroundContainer = styled.div<{ url: string; tabletUrl?: string; desktopUrl?: string }>`
  background-image: url(${({ url }) =>
    generateThumborImgUrl({
      src: url,
      width: 768,
      height: 393,
    })});

  // Hack: Image gets a little weird if we try to stretch the mobile image more than about 500px
  @media (min-width: 500px) {
    background-image: url(${({ tabletUrl, url }) =>
      generateThumborImgUrl({
        src: tabletUrl ?? url,
        width: 992,
        height: 450,
      })});
  }

  ${minScreen(ScreenWidth.MEDIUM)} {
    background-image: url(${({ desktopUrl, url }) =>
      generateThumborImgUrl({
        src: desktopUrl ?? url,
        width: 1200,
        height: 166,
      })});
  }

  ${minScreen(ScreenWidth.LARGE)} {
    background-image: url(${({ desktopUrl, url }) =>
      generateThumborImgUrl({
        src: desktopUrl ?? url,
        width: 2400,
        height: 332,
      })});
  }

  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
`;

export const MaxWidthContainer = styled(DishFirstExploreWidthLimit)`
  margin-top: ${Spacing.SINGLE};
  margin-bottom: ${Spacing.SINGLE};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  cursor: default;
`;
export const SeeAllButton = styled.span`
  font-size: ${Font.Size.S};
  text-decoration: underline;
  font-family: ${Font.Family.SANS};
  color: ${Colors.GRAY_DARK_15};

  cursor: pointer;
  user-select: none;
  display: block;
  z-index: 0;
`;

export const RowContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;

  ${minScreen(ScreenWidth.MEDIUM)} {
    width: 100%;
    padding: 0 ${PADDING}px;
  }
`;

export const ShefSeeAllCard = styled(SeeAllCard)`
  height: 263px;
`;
